const FalenciaRecuperacaoJudicial = ({ falenciaRecuperacaoJudicial }) => {
  if (
    !falenciaRecuperacaoJudicial ||
    falenciaRecuperacaoJudicial.length === 0
  ) {
    return (
      <div className="text-sm text-gray-500 italic">
        Nenhuma ocorrência de falência ou recuperação judicial encontrada.
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-gray-200 overflow-hidden">
      <div className="bg-blue-50 px-4 py-3 border-b border-gray-200">
        <div className="grid grid-cols-3 gap-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">
          <div>Tipo</div>
          <div>Data</div>
          <div>Cidade / UF</div>
        </div>
      </div>

      {falenciaRecuperacaoJudicial.map((ocorrencia, index) => (
        <div
          key={index}
          className={`grid grid-cols-3 gap-4 px-4 py-3 text-sm items-center ${
            index % 2 === 0 ? "bg-white" : "bg-gray-50"
          }`}
        >
          <div className="font-medium text-gray-900">
            {ocorrencia?.tipo_ocorrencia || "-"}
          </div>
          <div className="text-gray-700">{ocorrencia?.data || "-"}</div>
          <div className="text-gray-700">
            {ocorrencia?.cidade || "-"} / {ocorrencia?.uf || "-"}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FalenciaRecuperacaoJudicial;
